import { render, staticRenderFns } from "./PopManualFormBox.vue?vue&type=template&id=a237128e"
import script from "./PopManualFormBox.vue?vue&type=script&lang=js"
export * from "./PopManualFormBox.vue?vue&type=script&lang=js"
import style0 from "./PopManualFormBox.vue?vue&type=style&index=0&id=a237128e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports